exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-components-organisms-Project-___Project__container___3NP9v {\n  width: 100vw;\n  height: 100%;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.src-sp-components-organisms-Project-___Project__lImageView___3Kjo4 {\n  -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2;\n  height: calc(100vh / 3 * 2);\n  overflow: hidden;\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-sp-components-organisms-Project-___Project__container___3NP9v",
	"lImageView": "src-sp-components-organisms-Project-___Project__lImageView___3Kjo4"
};